import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { useRouter } from 'next/router'
import { selector } from '@/src/redux/store'
import { IS_LOGIN } from '@/src/redux/state'
import { useBackend } from '@/src/providers/BackendProvider'
import SpinningCircle from '@/src/components/SpinningCircle'

const RequireLogin = ({ children }) => {
  const router = useRouter()
  const unsignedInDelayedRef = useRef()
  const userInfo = useSelector(selector.selectUserInfo)
  const { signedin } = useBackend()

  useEffect(() => {
    ;(async () => {
      if (userInfo[IS_LOGIN] === undefined) return
      if (!userInfo[IS_LOGIN]) {
        unsignedInDelayedRef.current = setTimeout(() => {
          router.replace(
            '/SignIn' +
              `?redirect_uri=${encodeURIComponent(
                location.origin + location.pathname + location.search
              )}`
          )
        }, 1000)
      } else {
        if (unsignedInDelayedRef.current != null) {
          clearTimeout(unsignedInDelayedRef.current)
          unsignedInDelayedRef.current = null
        }
      }
    })()
  }, [userInfo[IS_LOGIN]])

  if (!signedin) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        m="24px 0"
      >
        <SpinningCircle />
      </Box>
    )
  }

  return <>{children}</>
}

export default RequireLogin
